<section class="relative" [cdkMenuTriggerFor]="picker">
  <app-input
    [color]="currentColor()"
    [size]="currentSize()"
    [rounded]="currentRounded()"
    (inputClick)="open.set(true)"
    [label]="label()"
    [required]="required()"
    [placeholder]="placeholder()"
    [spellcheck]="spellcheck()"
    [autocomplete]="autocomplete()"
    [autofocus]="autofocus()"
    [(value)]="value"
    readonly
    [suffixIcon]="icon() || 'ic:baseline-access-alarm'"
    (inputFocus)="open.set(true)"
  />
</section>

<ng-template #picker>
  <app-time-picker
    cdkMenu
    [currentTime]="value()"
    class="absolute z-10 min-size-full w-max"
    (pick)="pick($event)"
  />
</ng-template>
